import React, { useMemo } from "react";
import '../assets/css/pages/Contact.css'
import '../assets/css/Responsive/Contact_Responsive.css'

const sanitize = (value) => (typeof value === "string" ? value.trim() : "");

const sanitizeImage = (image) => {
    if (!image) return null;
    const url = sanitize(image?.url || "");
    if (!url) return null;
    return { url, alt: sanitize(image?.alt || "") };
};

// Helper function to check if a value is an email address
const isEmail = (value) => {
    if (!value || typeof value !== "string") return false;
    // Simple email regex pattern
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(value.trim());
};

const ContactSection = ({ fields }) => {
    const sanitizedData = useMemo(() => {
        if (!fields) return null;

        const heading = sanitize(fields.heading || "");
        const subtext = sanitize(fields.subtext || "");

        const items = Array.isArray(fields.items)
            ? fields.items
                .map((item) => {
                    const icon = sanitizeImage(item?.icon);
                    const label = sanitize(item?.label || "");
                    const value = sanitize(item?.value || "");

                    if (!icon || !label || !value) return null;

                    return { icon, label, value };
                })
                .filter(Boolean)
            : [];

        const image = sanitizeImage(fields.image);
        const imageMobile = sanitizeImage(fields.image_mobile);

        const hasContent = heading || subtext || items.length > 0 || image || imageMobile;
        if (!hasContent) return null;

        return {
            heading,
            subtext,
            items,
            image,
            imageMobile,
        };
    }, [fields]);

    if (!sanitizedData) return null;

    const { heading, subtext, items, image, imageMobile } = sanitizedData;

    return (
        <section className="contact-section ">
            <div className="canvas">
                <div className="contact-section-inner">
                    {/* LEFT SIDE */}
                    {(heading || subtext || items.length > 0) && (
                        <div className="contact-left">
                            {(heading || subtext) && (
                                <div className="contact-head " data-stagger-index="0">
                                    {heading && <h1>{heading}</h1>}
                                    {subtext && <p className="subtext opcity">{subtext}</p>}
                                </div>
                            )}

                            {items.length > 0 && (
                                <div className="contact-item-main ">
                                    {items.map((item, index) => (
                                        <div className="contact-item" key={`contact-item-${index}`} data-stagger-index={index + 1}>
                                            <img src={item.icon.url} alt={item.icon.alt || item.label} />
                                            <div>
                                                <p className="opcity">{item.label}</p>
                                                <p className={`contact-email ${index === 2 ? "ticket" : ""}`}>
                                                    {isEmail(item.value) ? (
                                                        <a href={`mailto:${item.value}`} className="email-link">
                                                            {item.value}
                                                        </a>
                                                    ) : (
                                                        item.value
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    {/* RIGHT SIDE IMAGE */}
                    {(image || imageMobile) && (
                        <div className="contact-right" data-stagger-index={items.length + 1}>
                            <picture>
                                {imageMobile && (
                                    <source
                                        media="(max-width: 767px)"
                                        srcSet={imageMobile.url}
                                    />
                                )}
                                {image && <img src={image.url} alt={image.alt || "Contact"} />}
                            </picture>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ContactSection;

